var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-card',{class:{ colored: _vm.colored }},[_c('q-card-section',[_c('q-card-section',{staticClass:"q-table__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('q-card-section',[_c('charts',{attrs:{"options":_vm.computedChart}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }